import { NavLink } from "react-router-dom"
import InfoIcon from "../../../assets/Images/sideDrawer/infoIcon"
import BankInfoIcon from "../../../assets/Images/sideDrawer/BankInfoIcon"
import EKycIcon from "../../../assets/Images/sideDrawer/EKycIcon"
import OverViewIcon from "../../../assets/Images/sideDrawer/OverViewIcon"
import EmploymentDetailsIcon from "../../../assets/Images/sideDrawer/EmploymentDetailsIcon"
import SetIcon from "../../../assets/Icons/SetIcon"
import DocumentIcon from "../../../assets/Icons/DocumentIcon"
import ChatIcon from "../../../assets/Icons/ChatIcon"
import NetworkIcon from "../../../assets/Icons/NetworkIcon"
import ProgressBar from "../../../components/ProgressBar"
import { Button } from "../../../components/Buttons"
import rightArrowIcon from "../../../assets/Images/icons/rightArrowIcon.svg"
import { DashboardRoutesLinks, RoutesLink } from "../../../router/RoutesLink";
import VerifyIcon from "../../../assets/Icons/VerifyIcon.js";
import PersonalInfoIcon from "../../../assets/Icons/PersonalInfoIcon.js";
import LogoutIcon from "../../../assets/Icons/LogoutIcon.js";

export const DrawerList = ({ drawerList, currentPath }) => {
  return drawerList.map((item) => {
    const { Icon } = item

    return (
      <li key={item} className="mt-[20px] ">
        <NavLink
          to={item.path}
          className={() => {
            let styles =
              "font-[400] font-Apparat text-[16px] tracking-[-2] leading-[20px] p-2 rounded cursor-pointer"
            return currentPath === item.path
              ? styles + " " + "text-primary"
              : styles
          }}
        >
          <span className="inline-flex justify-center items-center">
            {Icon ? (
              <Icon
                color={
                  currentPath === item.path ? "#E53F50" : "#424952"
                }
              />
            ) : item.img}
            <span className="ml-[8px] ">{item.title}</span>
          </span>
        </NavLink>
      </li>
    )
  })

}

const SidebarList = ({ className = "" }) => {
  const currentPath = window.location.pathname;

  let width = window.screen.width;
  console.log("widthhh,...", width);
  const drawerList = [
    { title: width > 1024 ? "Overview" : "Dashboard", Icon: OverViewIcon, path: DashboardRoutesLinks.dashboard },
    {
      title: "Personal Information",
      Icon: InfoIcon,
      path: "/personalInformation",
    },
    { title: "E-KYC", Icon: EKycIcon, path: DashboardRoutesLinks?.ekyc },
    { title: "Bank Information", Icon: BankInfoIcon, path: DashboardRoutesLinks?.bankDetails },
    {
      title: "Employment Details",
      Icon: EmploymentDetailsIcon,
      path: DashboardRoutesLinks.employmentDetails,
    },
  ];
  const drawerList2 = [
    { title: "My Loans", img: <SetIcon />, path: DashboardRoutesLinks?.myLoans },
    { title: "Documents", img: <DocumentIcon />, path: DashboardRoutesLinks?.documents },
    { title: "My Support Ticket", img: <ChatIcon />, path: "#" },
    { title: "My Credit Analysis", img: <NetworkIcon />, path: "#" },
  ];

  const drawerList3 = [
    { title: "My Account", img: <PersonalInfoIcon />, path: DashboardRoutesLinks?.myAccount },
    { title: "Sign in & Security", img: <VerifyIcon />, path: DashboardRoutesLinks?.documents },
    { title: "Legal Documents", img: <DocumentIcon />, path: "#" },
    { title: "Logout", img: <LogoutIcon />, path: "#" },
  ];
  return (<>
    <div className={`p-4 mt-[20px] lg:pl-[40px]  xl:pl-[100px]  bg-white pb-[150px] ${className}`}>
      <div className="flex flex-col gap-[16px] ">
        <p className="font-[500] text-[24px] text-[#262626] leading-[32px] tracking-[-2%]">
          You're close to <br /> applying for a loan!
        </p>
        <ProgressBar />
        <Button variant="secondary" className=" text-primary">
          <div className="flex items-center justify-center gap-1">
            {" "}
            <span className="font-[600] text-[16px] leading-[16px]">
              Update
            </span>{" "}
            <img src={rightArrowIcon} />
          </div>
        </Button>
      </div>
      <ul className="mt-4">
        <DrawerList drawerList={drawerList} currentPath={currentPath} />
      </ul>
      <hr />
      <div className="flex flex-col gap-[2px] mt-4">
        {width > 1024 && <p className="font-Apparat font-bold text-[12px] leading-[20px] tracking-[28%] text-[#42495280]">
          QUICK LINKS
        </p>}
        <ul >
          <DrawerList drawerList={drawerList2} currentPath={currentPath} />
        </ul>
      </div>
      {width < 1024 && <>
        <hr />
        <div className="flex flex-col gap-[2px] mt-4">
          <ul >
            <DrawerList drawerList={drawerList3} currentPath={currentPath} />
          </ul>
        </div>
      </>}


    </div>
  </>)
}

export default SidebarList;